<template>
	<div class="bg-container">
		<div class="title">
			{{ tipTitle }}
		</div>
		<div class="tip">
			<div>{{ explain }}</div>
			<div>
				<el-tooltip placement="top" v-if="tips">
					<div slot="content" class="tipcontent">
						<div v-html="tips" class="info" style="line-height: 20px; font-size: 12px"></div>
					</div>

					<ig-icon name="tishi" class="infopointer"></ig-icon>
				</el-tooltip>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		tipTitle: null,
		explain: null,
		tips: null,
		tipsExplain: null,
	},

	data() {
		return {};
	},

	components: {},

	computed: {},

	methods: {},
};
</script>

<style lang="scss" scoped>
.bg-container {
	height: auto;
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	border-radius: 4px;
	padding: 20px 25px;
	.title {
		font-weight: bold;
		color: rgba(0, 0, 0, 0.85);
		font-size: 16px;
		margin-bottom: 15px;
	}
	.tip {
		display: flex;
		font-size: 14px;
		color: #999999;
		line-height: 22px;
	}

	.infopointer {
		cursor: pointer;
	}
}
</style>
